export const productReportFilterState = (venueId) => ({
  venueId,
  page: 1,
  pageSize: 20,
  locations: [],
  measurement: null,
  searchKey: "",
  sort: { key: "name", value: "asc" },
});
